import { render, staticRenderFns } from "./Presence.vue?vue&type=template&id=22f7427d&scoped=true"
import script from "./Presence.vue?vue&type=script&lang=js"
export * from "./Presence.vue?vue&type=script&lang=js"
import style0 from "./Presence.vue?vue&type=style&index=0&id=22f7427d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f7427d",
  null
  
)

export default component.exports